import React, { FC } from "react";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import Sticker from "../../../../../components/elements/sticker/Sticker";
import FlexLine from "../../../../../components/elements/flexLine/FlexLine";
import Container from "../../../../../components/elements/container/Container";

import Tx from "../../../../../types/naming";
import { Align, Rotate, TextType } from "../../../../../types/baseType";
import ChartHeader from "../../../../../components/elements/chart/ChartHeader";
import st from "./styles.module.scss";
import cn from "classnames";
import List from "../../../../../components/elements/list/List";
import { CircleLabel } from "../../../works/detalization/dynamics";
import { stickerLoadingWithCrop } from "../../../phases";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../../store";
import { array, identity } from "fp-ts";
import { DetalizationCropState } from "../../../../../store/reducers/dashboard/crops/detalization";
import { formatNumber2d } from "@utils/format/number";
import { Empty } from "@pages/dashboard/crops/detalization/column/empty";

interface CropsColumnDashboard {
}

const CropsColumnDashboard: FC<CropsColumnDashboard> = (props) => {

  let {
    data
  } = useTypedSelector((state) => state.dashCropDetalization);

  const max = Math.max(...data.cultivatedArea.map(i => i.area.value));

  const { selected } = useTypedSelector(state => state.cropSelector);

  if (selected && array.isEmpty(selected)) {
      return <Empty/>
  }

  return (
    <Sticker className={st['columnSticker']}>
      <FlexLine textType={TextType.Header} className={st.header}>
        <ChartHeader>{Tx.Culture}</ChartHeader>
        <div className={st.total}>
          Всего {formatNumber2d(data.currentSeasonHa)} Га из {formatNumber2d(data.totalGeoZoneHa)}
        </div>
      </FlexLine>
      <Container className={st['columnContainer']}>
        <List className={st['columnList']}>
          {data.cultivatedArea.map((item, index) =>
              <FlexLine align={Align.SpaceBetween} key={item.cropId + `-${index}`} style={{ gap: 24 }}>
                <FlexLine className={st.line_title}>
                  <CircleLabel color={item.color} name={item.crops}/>
                </FlexLine>
                <FlexLine rotate={Rotate.Column}>
                  <FlexLine className={cn(st.line)}>
                    <div
                        className={cn(st.line__progress)}
                        style={{
                          width: (item.area.value / max) * 1e2 + "%",
                          background: item.color
                        }}
                    />
                  </FlexLine>
                </FlexLine>
                <FlexLine className={st.line_area}>
                  <div>{formatNumber2d(item.area.value)} {item.area.dimension}</div>
                </FlexLine>
              </FlexLine>
          )}
        </List>
      </Container>
    </Sticker>
  );
};

export default stickerLoadingWithCrop(
    createSelector((state: RootState) => state.dashCropDetalization, identity.of<DetalizationCropState>),
    () => () => ([])
)(CropsColumnDashboard);